import React from 'react';
import { BusinessUnitFilter, MemberFilter, PracticeFilter } from '~/components';
import useFeatures from '~/hooks/useFeatures.js';
import ContactTagFilter from './ContactTagFilter';
import FiltersGroup from './FiltersGroup';

function ContactFiltersGroup({ filters, onChange }) {
  const features = useFeatures();

  return (
    <FiltersGroup
      label="Contact Filters"
      filters={[filters.contactOwners, filters.contactPractices, filters.contactBusinessUnits, filters.contactTags]}>
      <MemberFilter
        name="contactOwners"
        placeholder="Contact Owner"
        value={filters.contactOwners}
        onChange={({ target: { value } }) => onChange({ contactOwners: value })}
      />

      {features.practices && (
        <PracticeFilter
          name="contactPractices"
          placeholder="Contact Practice"
          value={filters.contactPractices}
          onChange={({ target: { value } }) => onChange({ contactPractices: value })}
        />
      )}

      {features.businessUnits && (
        <BusinessUnitFilter
          name="contactBusinessUnits"
          placeholder="Contact Business Unit"
          value={filters.contactBusinessUnits}
          onChange={({ target: { value } }) => onChange({ contactBusinessUnits: value })}
        />
      )}

      <ContactTagFilter
        name="contactTags"
        placeholder="Contact Tags"
        value={filters.contactTags}
        onChange={({ target: { value } }) => onChange({ contactTags: value })}
      />
    </FiltersGroup>
  );
}

export default ContactFiltersGroup;
